module.exports = __webpack_public_path__ + "img/file-icon-xls.3308148c.svg";